import classNames from 'classnames';
import { useScroll } from 'framer-motion';
import { useRef } from 'react';
import { Document } from '@/entities/document';
import { tp } from '@/shared/lib/typograf';
import Breadcrumbs, { AppBreadcrumbs } from '../../shared/Breadcrumbs';
import DocumentLink from '../../shared/DocumentLink';
import GradientBG from '../../shared/GradientBG';
import Typografed from '../../shared/Typografed';

export type PageWelcomeDynamicBGProps = {
    title: string;
    description?: string;
    document?: Document | null;
    events: {
        title: string;
        text: string;
    }[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    breadcrumbs: AppBreadcrumbs;
    pageWelcomeDynamicBGProps?: PageWelcomeDynamicBGProps;
};

function PageWelcomeDynamicBG({ breadcrumbs, pageWelcomeDynamicBGProps, ...props }: Props) {
    const ref = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({ target: ref });

    return (
        <div
            {...props}
            className={classNames('page-welcome-dynamic-bg__section js-header-theme-trigger', props.className)}
            ref={ref}
            id="top"
        >
            <GradientBG scrollYProgress={scrollYProgress} />

            <div className="page-welcome__wrapper wrapper">
                <div className="page-welcome__top">
                    <Breadcrumbs className="participation-breadcrumbs" breadcrumbs={breadcrumbs} />
                </div>
                <div className="page-welcome__bottom">
                    {pageWelcomeDynamicBGProps && (
                        <h1 className="page-welcome__title h2">
                            <Typografed>{pageWelcomeDynamicBGProps?.title ?? ''}</Typografed>
                        </h1>
                    )}
                    {pageWelcomeDynamicBGProps?.description && (
                        <div
                            className="page-welcome__description text-xl text-opacity"
                            dangerouslySetInnerHTML={{ __html: tp(pageWelcomeDynamicBGProps.description) }}
                        ></div>
                    )}

                    {pageWelcomeDynamicBGProps?.document && (
                        <DocumentLink document={pageWelcomeDynamicBGProps.document} />
                    )}
                </div>
                {pageWelcomeDynamicBGProps && pageWelcomeDynamicBGProps?.events.length > 0 && (
                    <div className="page-welcome__events">
                        {pageWelcomeDynamicBGProps?.events.map((event) => (
                            <div className="page-welcome__event" key={event.title}>
                                {event.title && (
                                    <h3 className="page-welcome__event-title text-xs text-opacity">
                                        <Typografed>{event.title}</Typografed>
                                    </h3>
                                )}
                                {event.text && (
                                    <p
                                        className="page-welcome__event-text text-xl"
                                        dangerouslySetInnerHTML={{ __html: tp(event.text) }}
                                    ></p>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PageWelcomeDynamicBG;
